import {ResourceType} from '../../../models/mongoose/PermissionModel/enum/ResourceType'

export const CollectableResourceTypeSet = new Set<ResourceType>([
  ResourceType.Database,
  ResourceType.Document,
  ResourceType.Whiteboard,
  ResourceType.Dashboard,
  ResourceType.Conversation,
  ResourceType.CallRoom,
  ResourceType.Skill,
  ResourceType.Agent,
  ResourceType.Automation,
  ResourceType.Folder,
  ResourceType.Cron,
  ResourceType.WebhookListener,
  ResourceType.Connection,
  ResourceType.App,
])

export function isCollectableResourceType(resourceType: ResourceType): boolean {
  return CollectableResourceTypeSet.has(resourceType)
}
